var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9628 12.9557C18.1442 12.5237 17.6259 12.1557 17.1913 12.3477C16.3224 12.7291 15.3836 12.9253 14.4348 12.9237C10.7148 12.9237 7.69961 9.96902 7.69961 6.32365C7.69825 5.09283 8.04793 3.88715 8.70762 2.84806C8.96007 2.44983 8.65695 1.89872 8.19473 2.01605C4.63114 2.92539 2 6.10054 2 9.87746C2 14.3637 5.71115 18.0002 10.2899 18.0002C13.7566 18.0002 16.7255 15.9157 17.9628 12.9557Z",
    fill: "#00AEEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.21 2.09137C12.7388 1.7767 12.1771 2.33849 12.4908 2.8096L13.0508 3.64961C13.278 3.9902 13.3992 4.39044 13.3992 4.79984C13.3992 5.20925 13.278 5.60948 13.0508 5.95008L12.4908 6.79009C12.1771 7.2612 12.7397 7.82298 13.2108 7.50832L14.05 6.94831C14.3906 6.72114 14.7908 6.59991 15.2002 6.59991C15.6096 6.59991 16.0098 6.72114 16.3504 6.94831L17.1904 7.50832C17.6616 7.82298 18.2233 7.2612 17.9087 6.79009L17.3487 5.95008C17.1215 5.60948 17.0003 5.20925 17.0003 4.79984C17.0003 4.39044 17.1215 3.9902 17.3487 3.64961L17.9087 2.8096C18.2233 2.33849 17.6616 1.7767 17.1896 2.09137L16.3504 2.65138C16.0098 2.87855 15.6096 2.99978 15.2002 2.99978C14.7908 2.99978 14.3906 2.87855 14.05 2.65138L13.21 2.09137Z",
    fill: "#00AEEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNight);
export default __webpack_public_path__ + "static/media/night.c0e45299296f59991abb6ed8c79867a3.svg";
export { ForwardRef as ReactComponent };